/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import Dimensions from 'pages/dashboard/reports/detail/dimensions/dimensions';



/* ========== ~~~~~~~~~~ REPORT DIMENSIONS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState }) => ({
    dimensions: reportsState.selectedReportStatus.selectedReportData.dimensions, 
    order: reportsState.selectedReportStatus.selectedReportData.order, 
    valid: reportsState.selectedReportStatus.selectedReportData.selectedReportDataValid,
    reportChangeDetected: reportsState.selectedReportStatus.status.reportChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
    setReportProperties: properties => dispatch(setReportProperties(properties))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dimensions);